/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Reward } from '../../models/reward';

export interface GetLoyaltyProgramReward$Params {
  'Active-Tenant-Identifier': string;
  programId: string;
  rewardId: string;
}

export function getLoyaltyProgramReward(http: HttpClient, rootUrl: string, params: GetLoyaltyProgramReward$Params, context?: HttpContext): Observable<StrictHttpResponse<Reward>> {
  const rb = new RequestBuilder(rootUrl, getLoyaltyProgramReward.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('programId', params.programId, {});
    rb.path('rewardId', params.rewardId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Reward>;
    })
  );
}

getLoyaltyProgramReward.PATH = '/loyalty/programs/{programId}/rewards/{rewardId}';
